import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { AuthorDataFragmentDoc } from './GetArticleByUrl.query';
export type GetGuideArticlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	first: Types.Scalars['Int']['input'];
	offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
	filter?: Types.ArticleFilter;
	profile?: Types.InputMaybe<Types.BackdropProfile>;
	format?: Types.InputMaybe<Types.ImageFormat>;
	includeAllTitlesAndPosters?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetGuideArticlesQuery = {
	__typename?: 'Query';
	articles: {
		__typename?: 'ArticlesConnection';
		totalCount: number;
		edges?: Array<{
			__typename?: 'ArticlesEdge';
			node: {
				__typename: 'Article';
				id: string;
				author: {
					__typename: 'Author';
					id: string;
					content: {
						__typename?: 'AuthorContent';
						bio: string;
						clearName: string;
						imageUrl?: string | null;
						fullPath: string;
						alumniOf: Array<string>;
						brand: string;
						languagesSpoken: Array<any>;
						occupation: Array<string>;
						publications?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
						socialHandles?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
					};
				};
				content: {
					__typename: 'ArticleContent';
					id: number;
					articleType: Types.ArticleType;
					title?: string | null;
					subtitle?: string | null;
					paragraph1?: string | null;
					fullPath: string;
					headerImage?: { __typename?: 'ArticleImage'; url: string; altText: string } | null;
					mainImageEntityBackdrop?: { __typename?: 'Backdrop'; backdropUrl: string } | null;
				};
				mainObjects: Array<{
					__typename?: 'ArticleLinkedObject';
					node:
						| { __typename: 'Article'; id: string }
						| { __typename: 'Author'; id: string }
						| { __typename: 'Bundle'; id: string }
						| { __typename: 'Device'; id: string }
						| { __typename: 'Episode'; id: string }
						| {
								__typename: 'GenericTitleList';
								id: string;
								titles: {
									__typename?: 'GenericTitleListConnection';
									edges?: Array<{
										__typename?: 'GenericTitleListEdge';
										nodeV2:
											| {
													__typename?: 'Movie';
													id: string;
													content: {
														__typename?: 'MovieContent';
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
													};
											  }
											| {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
													};
											  }
											| {
													__typename?: 'Show';
													id: string;
													content: {
														__typename?: 'ShowContent';
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
													};
											  };
									}> | null;
								};
								allTitles: {
									__typename?: 'GenericTitleListConnection';
									totalCount: number;
									edges?: Array<{
										__typename?: 'GenericTitleListEdge';
										nodeV2:
											| {
													__typename: 'Movie';
													id: string;
													objectType: Types.ObjectType;
													objectId: number;
													content: {
														__typename?: 'MovieContent';
														title: string;
														fullPath: string;
														posterUrl?: string | null;
													};
											  }
											| {
													__typename: 'Season';
													id: string;
													objectType: Types.ObjectType;
													objectId: number;
													content: {
														__typename?: 'SeasonContent';
														title: string;
														fullPath: string;
														posterUrl?: string | null;
													};
											  }
											| {
													__typename: 'Show';
													id: string;
													objectType: Types.ObjectType;
													objectId: number;
													content: {
														__typename?: 'ShowContent';
														title: string;
														fullPath: string;
														posterUrl?: string | null;
													};
											  };
									}> | null;
								};
						  }
						| { __typename: 'Genre'; id: string }
						| { __typename: 'HomePage'; id: string }
						| {
								__typename: 'Movie';
								id: string;
								content: {
									__typename?: 'MovieContent';
									backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								};
						  }
						| { __typename: 'MultiStepSportEvent'; id: string }
						| { __typename: 'Offer'; id: string }
						| { __typename: 'OfferHistory'; id: string }
						| { __typename: 'Package'; id: string }
						| { __typename: 'Page'; id: string }
						| { __typename: 'Person'; id: string }
						| { __typename: 'ProfileV2'; id: string }
						| {
								__typename: 'Season';
								id: string;
								content: {
									__typename?: 'SeasonContent';
									backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								};
						  }
						| {
								__typename: 'Show';
								id: string;
								content: {
									__typename?: 'ShowContent';
									backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								};
						  }
						| { __typename: 'SingleStepSportEvent'; id: string }
						| { __typename: 'SportCompetitionV2'; id: string }
						| { __typename: 'SportCompetitorV2'; id: string }
						| { __typename: 'SportMatch'; id: string }
						| { __typename: 'Url'; id: string };
				}>;
			};
		}> | null;
	};
};

export type GuideEntryFragment = {
	__typename: 'Article';
	id: string;
	author: {
		__typename: 'Author';
		id: string;
		content: {
			__typename?: 'AuthorContent';
			bio: string;
			clearName: string;
			imageUrl?: string | null;
			fullPath: string;
			alumniOf: Array<string>;
			brand: string;
			languagesSpoken: Array<any>;
			occupation: Array<string>;
			publications?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
			socialHandles?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
		};
	};
	content: {
		__typename: 'ArticleContent';
		id: number;
		articleType: Types.ArticleType;
		title?: string | null;
		subtitle?: string | null;
		paragraph1?: string | null;
		fullPath: string;
		headerImage?: { __typename?: 'ArticleImage'; url: string; altText: string } | null;
		mainImageEntityBackdrop?: { __typename?: 'Backdrop'; backdropUrl: string } | null;
	};
	mainObjects: Array<{
		__typename?: 'ArticleLinkedObject';
		node:
			| { __typename: 'Article'; id: string }
			| { __typename: 'Author'; id: string }
			| { __typename: 'Bundle'; id: string }
			| { __typename: 'Device'; id: string }
			| { __typename: 'Episode'; id: string }
			| {
					__typename: 'GenericTitleList';
					id: string;
					titles: {
						__typename?: 'GenericTitleListConnection';
						edges?: Array<{
							__typename?: 'GenericTitleListEdge';
							nodeV2:
								| {
										__typename?: 'Movie';
										id: string;
										content: {
											__typename?: 'MovieContent';
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										};
								  }
								| {
										__typename?: 'Season';
										id: string;
										content: {
											__typename?: 'SeasonContent';
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										};
								  }
								| {
										__typename?: 'Show';
										id: string;
										content: {
											__typename?: 'ShowContent';
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										};
								  };
						}> | null;
					};
					allTitles: {
						__typename?: 'GenericTitleListConnection';
						totalCount: number;
						edges?: Array<{
							__typename?: 'GenericTitleListEdge';
							nodeV2:
								| {
										__typename: 'Movie';
										id: string;
										objectType: Types.ObjectType;
										objectId: number;
										content: {
											__typename?: 'MovieContent';
											title: string;
											fullPath: string;
											posterUrl?: string | null;
										};
								  }
								| {
										__typename: 'Season';
										id: string;
										objectType: Types.ObjectType;
										objectId: number;
										content: {
											__typename?: 'SeasonContent';
											title: string;
											fullPath: string;
											posterUrl?: string | null;
										};
								  }
								| {
										__typename: 'Show';
										id: string;
										objectType: Types.ObjectType;
										objectId: number;
										content: {
											__typename?: 'ShowContent';
											title: string;
											fullPath: string;
											posterUrl?: string | null;
										};
								  };
						}> | null;
					};
			  }
			| { __typename: 'Genre'; id: string }
			| { __typename: 'HomePage'; id: string }
			| {
					__typename: 'Movie';
					id: string;
					content: {
						__typename?: 'MovieContent';
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					};
			  }
			| { __typename: 'MultiStepSportEvent'; id: string }
			| { __typename: 'Offer'; id: string }
			| { __typename: 'OfferHistory'; id: string }
			| { __typename: 'Package'; id: string }
			| { __typename: 'Page'; id: string }
			| { __typename: 'Person'; id: string }
			| { __typename: 'ProfileV2'; id: string }
			| {
					__typename: 'Season';
					id: string;
					content: {
						__typename?: 'SeasonContent';
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					};
			  }
			| {
					__typename: 'Show';
					id: string;
					content: {
						__typename?: 'ShowContent';
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					};
			  }
			| { __typename: 'SingleStepSportEvent'; id: string }
			| { __typename: 'SportCompetitionV2'; id: string }
			| { __typename: 'SportCompetitorV2'; id: string }
			| { __typename: 'SportMatch'; id: string }
			| { __typename: 'Url'; id: string };
	}>;
};

export type JustBackdrops_Movie_Fragment = {
	__typename?: 'Movie';
	content: { __typename?: 'MovieContent'; backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }> };
};

export type JustBackdrops_Season_Fragment = {
	__typename?: 'Season';
	content: { __typename?: 'SeasonContent'; backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }> };
};

export type JustBackdrops_Show_Fragment = {
	__typename?: 'Show';
	content: { __typename?: 'ShowContent'; backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }> };
};

export type JustBackdropsFragment =
	| JustBackdrops_Movie_Fragment
	| JustBackdrops_Season_Fragment
	| JustBackdrops_Show_Fragment;

export const JustBackdropsFragmentDoc = gql`
	fragment JustBackdrops on MovieOrShowOrSeason {
		content(country: $country, language: $language) {
			backdrops {
				backdropUrl
			}
		}
	}
`;
export const GuideEntryFragmentDoc = gql`
	fragment GuideEntry on Article {
		id
		__typename
		author {
			... on Author {
				id
				__typename
				content(country: $country, language: $language) {
					...AuthorData
				}
			}
		}
		content {
			id
			__typename
			articleType
			title
			subtitle
			paragraph1
			fullPath
			headerImage {
				url
				altText
			}
			mainImageEntityBackdrop(profile: $profile, format: $format) {
				backdropUrl
			}
		}
		mainObjects: linkedObjects(priority: 1) {
			node {
				id
				__typename
				...JustBackdrops
				... on GenericTitleList {
					titles(country: $country, first: 1, sortBy: NATURAL) {
						edges {
							nodeV2 {
								id
								...JustBackdrops
							}
						}
					}
				}
				... on GenericTitleList @include(if: $includeAllTitlesAndPosters) {
					allTitles: titles(country: $country, sortBy: NATURAL) {
						totalCount
						edges {
							nodeV2 {
								id
								__typename
								objectType
								objectId
								content(country: $country, language: $language) {
									title
									fullPath
									posterUrl(profile: S276)
								}
							}
						}
					}
				}
			}
		}
	}
	${AuthorDataFragmentDoc}
	${JustBackdropsFragmentDoc}
`;
export const GetGuideArticlesDocument = gql`
	query GetGuideArticles(
		$country: Country!
		$language: Language!
		$site: String
		$first: Int!
		$offset: Int = 0
		$filter: ArticleFilter! = { articleTypes: [NEWS_ARTICLE] }
		$profile: BackdropProfile
		$format: ImageFormat
		$includeAllTitlesAndPosters: Boolean = false
	) {
		articles(country: $country, site: $site, first: $first, filter: $filter, offset: $offset) {
			totalCount
			edges {
				node {
					... on Article {
						...GuideEntry
					}
				}
			}
		}
	}
	${GuideEntryFragmentDoc}
`;
